import React, { Component } from "react";
import "./partnerItem.scss";

import { env } from "../../../../../shared/environment/index";

import { Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";

import zero from "../../../../../shared/assets/images/zero.svg";

class PartnerItem extends Component {
  imgPrefix = env.imgUrl;
  baseUrl = env.baseUrl


  constructor(props) {
    super(props);

    this.state = {
      isNotOverpayment: null
    }

    this.scrollToTop = this.scrollToTop.bind(this);
  }

  headLabelColor() {
    if (this.props && this.props.data && this.props.data.period) {
      switch (this.props.data.period) {
        case 1:
          return "head-label yellow";
        case 2:
          return "head-label salad";
        case 3:
          return "head-label purple";
        case 4:
          return "head-label sky";
        case 5:
          return "head-label dark-red";
        case 6:
          return "head-label red";
        case 7:
          return "head-label orange";
        case 12:
          return "head-label yellow";
        default:
          return "head-label default";
      }
    }
  }

  scrollToTop() {
    scroll.scrollToTop();
  }

  getMonthValue() {
    if (this.props.data.period === 1) {
      return "месяц";
    } else if (this.props.data.period > 1 && this.props.data.period < 5) {
      return "месяца";
    } else if (this.props.data.period > 4) {
      return "месяцев";
    }
  }

  render() {
    return (
      <div className="partner-item-col">
        <Link
          to={"/partners/" + this.props.data.link}
          onClick={this.scrollToTop}
          className="partner-item-link"
        >
          <div className="partner-item card">

            {this.props.data.haveSalom ? (
              <img src={zero} className="zero-icon" alt="zero" />
            ) : (
                <></>
              )}

            {
              window.innerWidth < 768 ?
                <div className="partner-item-body">
                  <img
                    className="partner-logo"
                    src={this.imgPrefix + this.props.data.imagePath}
                    alt="partner-logo"
                  />

                  <div className="">
                    <h5 className="partner-item-title">
                      {this.props.data.name}{" "}
                      <span className="partner-item-period">
                        {" "}
                        • {this.props.data.period} мес.
                      </span>
                    </h5>
                    <p className="partner-item-category">
                      {this.props.data.category}
                    </p>
                  </div>
                </div> :
                <>
                  <div className="partner-logo-body">
                    <img
                      className="partner-logo"
                      src={this.imgPrefix + this.props.data.imagePath}
                      alt="partner-logo"
                    />

                  </div>
                  <div className="">
                    <h5 className="partner-item-title">
                      {this.props.data.name}{" "}
                      <span className="partner-item-period">
                        {" "}
                        • {this.props.data.period} мес.
                      </span>
                    </h5>
                    <p className="partner-item-category">
                      {this.props.data.category}
                    </p>
                  </div>
                </>
            }
            {/* <div className="partner-head">
                            <div className={this.headLabelColor()}>
                                {this.props.data.period} мес.
                            </div>
                        </div>
                        <div className="partner-body">
                            <div className="partner-logo">
                                <img className="" src={this.imgPrefix + this.props.data.imagePath} alt="partner-logo" />
                            </div>
                        </div>
                        <div className={this.headLabelColor() + ' partner-item-content d-none d-xl-block'}>
                            <div className="text-center">
                                <div className="title-h3-white">{this.props.data.period} {this.getMonthValue()}</div>
                                {
                                    this.props.data.haveSalom ? (
                                        <div className="title-small">Без комиссии<br />
                                            и предоплаты</div>
                                    ) : null
                                }

                            </div>
                        </div>
                        <div className="partner-footer">
                            <div className="row">
                                <div className="col-8">
                                    <div className="footer-title">
                                        {this.props.data.name}
                                    </div>
                                    <div className="footer-description">
                                        {this.props.data.category}
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="partner-link">
                                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                                    </div>
                                </div>
                            </div>
                        </div> */}
          </div>
        </Link>
      </div>
    );
  }
}

export default PartnerItem;
